import ICreature from "../Models/ICreature";

const creatures: { [id: string]: ICreature } =
{
    "harlequin_bug": {
        "name": "Punaise arlequin",
        "image": "/image/creatures/harlequin_bug.png",
        "hp": {
            2: 6,
            3: 6,
            4: 8,
            5: 8,
            6: 12
        }
    },
    "mechanical_bee": {
        "name": "Abeille mécanique",
        "image": "/image/creatures/mechanical_bee.png",
        "hp": {
            2: 8,
            3: 8,
            4: 12,
            5: 12,
            6: 15
        }
    },
    "generator_electric": {
        "name": "Générateur électrique",
        "image": "/image/creatures/generator_electric.png",
        "hp": {
            2: 25,
            3: 25,
            4: 40,
            5: 40,
            6: 50
        }
    },
    "jagged_sorceress": {
        "name": "Magicienne dentelée",
        "image": "/image/creatures/jagged_sorceress.png",
        "hp": {
            2: 25,
            3: 25,
            4: 35,
            5: 35,
            6: 45
        }
    },
    "praying_mantis": {
        "name": "Mante religieuse",
        "image": "/image/creatures/praying_mantis.png",
        "hp": {
            2: 30,
            3: 30,
            4: 45,
            5: 45,
            6: 60
        }
    },
    "dragonfly": {
        "name": "Libellule",
        "image": "/image/creatures/dragonfly.png",
        "hp": {
            2: 40,
            3: 40,
            4: 60,
            5: 60,
            6: 80
        }
    },
    "wall_lizard": {
        "name": "Lézard des murailles",
        "image": "/image/creatures/wall_lizard.png",
        "hp": {
            2: 15,
            3: 15,
            4: 25,
            5: 25,
            6: 30
        }
    },
    "green_tree_frog": {
        "name": "Rainette verte",
        "image": "/image/creatures/green_tree_frog.png",
        "hp": {
            2: 40,
            3: 40,
            4: 60,
            5: 60,
            6: 80
        }
    },
    "horde_of_ants": {
        "name": "Horde de fourmis",
        "image": "/image/creatures/horde_of_ants.png",
        "hp": {
            2: 30,
            3: 30,
            4: 45,
            5: 45,
            6: 60
        }
    },
    "yellow_legged_hornet": {
        "name": "Frelon à pattes jaunes",
        "image": "/image/creatures/yellow_legged_hornet.png",
        "hp": {
            2: 25,
            3: 25,
            4: 35,
            5: 35,
            6: 45
        }
    },
    "hornet_founder": {
        "name": "Fondatrice frelon",
        "image": "/image/creatures/hornet_founder.png",
        "hp": {
            2: 75,
            3: 75,
            4: 120,
            5: 120,
            6: 150
        }
    },
    "menardi_spider": {
        "name": "Araignée menardi",
        "image": "/image/creatures/menardi_spider.png",
        "hp": {
            2: 50,
            3: 50,
            4: 75,
            5: 75,
            6: 100
        }
    },
    // "termites": {
    //     "name": "Termites",
    //     "image": "/image/creatures/termites.png",
    //     "hp": {
    //         2: 6,
    //         3: 6,
    //         4: 8,
    //         5: 8,
    //         6: 12
    //     }

    // }
}

export default creatures;